export default "__VITE_ASSET__BlMn8kgP__"